function initBundleDeal( )
{
    document.addEventListener( "click", handleBundleaATCClick );
    document.addEventListener( "click", handleBundleClick );
}

function handleBundleaATCClick( e )
{
    if ( e.target.matches( ".bundle-deal-atc" ) )
    {
        var input = document.querySelector( ".bundle-label .bundle-input:checked" );
        if ( input )
        {
            var quickViewModal = input.closest( "quick-view-modal" );
            var itemQuantity = input.getAttribute( "value" );
            var variantId = JSON.parse( document.querySelector( "[data-selected-variant]" ).innerHTML ).id;
            if ( variantId )
            {
                let formData =
                {
                    'items': 
                    [
                        {
                            'id': variantId,
                            'quantity': itemQuantity
                        }
                    ]
                };
                
                fetch( window.Shopify.routes.root + 'cart/add.js',
                    {
                        method: 'POST',
                        headers:
                        {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify( formData )
                    })
                .then( response =>
                {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',
                        {
                            bubbles: true,
                            detail:
                            {
                                open: true
                            }
                        }
                    ));
                    if ( quickViewModal )
                    {
                        quickViewModal.hide( true )
                    }
                    return response.json();
                })
                .catch( ( error ) =>
                {
                    console.error( 'Error:', error );
                });
            }
            else
            {
                console.log( "No variant attribute, unable to add to cart." );
            }            
        }
    }
}

function handleBundleClick( e )
{
    //can't directly target label as inner element clicks won't be registered
    if ( e.target.closest( ".quick-add__content .bundle-label" ) && window.innerWidth < 769 )  
    {
        var atc = document.querySelector( ".quick-add__content .bundle-deal-atc" );
        atc.scrollIntoView( { behavior: "smooth", block: "center", inline: "center" } );
    }
}

initBundleDeal( );